import { SearchField } from './Input'

interface SearchBarProps {
  value: string
  onChange: (value: string) => void
  onSubmit?: (value: string) => void
  placeholder?: string
}

export function SearchBar({ value, onChange, onSubmit, placeholder = 'Search...' }: SearchBarProps) {
  return (
    <SearchField value={value} onChange={onChange} onSubmit={onSubmit} placeholder={placeholder} />
  )
}
